import { io } from 'socket.io-client';
import { socketUrl } from '../services/apiService/baseUrl';
export const socket = io(socketUrl);
export const socket2 = io("https://alpha-socket.app-assertai.com");
